import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=df6c79a4&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=df6c79a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6c79a4",
  null
  
)

export default component.exports